import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { persistStorage } from '@/tutorial/storage';

export interface CompanyContext {
  id: string;
  tenantId: string;
  name: string;
  tradeName?: string | null;
  cnpj?: string | null;
  logoUrl?: string | null;
  role?: 'OWNER' | 'ADMIN' | 'TEAM';
  permissions?: Record<string, boolean>;
  isOwner?: boolean;
}

interface CompanyState {
  companies: CompanyContext[];
  activeCompany: CompanyContext | null;
  setCompanies: (companies: CompanyContext[]) => void;
  setActiveCompany: (company: CompanyContext | null) => void;
  clearCompanies: () => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set, get) => ({
      companies: [],
      activeCompany: null,
      setCompanies: (companies) => {
        const current = get().activeCompany;
        const stillAllowed = current
          ? companies.find((company) => company.id === current.id)
          : null;

        set({
          companies,
          activeCompany: stillAllowed || companies[0] || null,
        });
      },
      setActiveCompany: (company) => set({ activeCompany: company }),
      clearCompanies: () => set({ companies: [], activeCompany: null }),
    }),
    {
      name: 'oprus-active-company',
      storage: createJSONStorage(persistStorage),
      partialize: (state) => ({ activeCompany: state.activeCompany }),
    },
  ),
);
